<template>
  <div class="element-video">
    <div
      :class="'float float--' + data.position + ' '"
      :style="{ '--bg-color': data.backgroundColor }"
    >
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-xl-10 col-xl-offset-1">
            <div class="float-elem">
              <div class="video-wrapper">
                <div
                  v-if="!videoPlayed"
                  class="video-cover"
                  :style="{ backgroundImage: 'url(' + data.image + ')' }"
                >
                  <div class="play-button" @click="play"></div>
                </div>

                <video 
                  v-if="videoType==='mp4' && videoPlayed"
                  width="1920" 
                  height="1080" 
                  autoplay
                  controls
                  data-category="Video" data-action="Watch" :data-label="data.title"
                >
                  <source :src="data.video" type="video/mp4">
                  
                </video>

                <iframe
                  v-if="videoType==='youtube' && videoPlayed"
                  :src="embedUrl"
                  :title="data.videoTitle"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  data-category="Video" data-action="Watch" :data-label="data.title"
                ></iframe>

                <iframe
                  v-if="videoType==='vimeo' && videoPlayed"
                  :src="embedUrl"
                  frameborder="0" 
                  allow="autoplay; fullscreen; picture-in-picture" 
                  allowfullscreen
                  data-category="Video" data-action="Watch" :data-label="data.title"
                ></iframe>
              </div>

              <div class="content-wrapper">
                <h4 class="title" v-if="data.showTitle">{{ data.title }}</h4>
                <div v-html="data.content"></div>
                <a v-if="data.link"
                  class="button button--solid-black"
                  :href="data.link"
                  :aria-label="data.label"
                  :title="data.label"
                  >{{ data.label }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "element-video",
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      videoPlayed: false,
      videoID: null,
      videoType: null
    };
  },
  methods: {
    play() {
      this.videoPlayed = true;
    },
  },
  computed: {
    embedUrl() {
      if(this.videoType==='youtube') {
        return "https://www.youtube.com/embed/" + this.videoID + "?autoplay=1";
      }
      if(this.videoType==='vimeo') {
        return "https://player.vimeo.com/video/" + this.videoID + "?autoplay=1";
      }
    },
  },
  created() {
    // set video type 
    if (this.data.video && this.data.video.includes('.mp4')) {
      this.videoType = 'mp4';
    }else{
      const url = new URL(this.data.videoUrl);

      if(this.data.videoUrl.includes('youtube')){
        let vidID = url.searchParams.get("v");
        
        this.videoType = 'youtube';
        this.videoID = vidID;
      }
      if(this.data.videoUrl.includes('vimeo')){
        const vimeoURL = this.data.videoUrl.replace(url.search, '');
        const urlParts = vimeoURL.split('vimeo.com/');

        this.videoType = 'vimeo';
        this.videoID = urlParts[1];
      }
    }
  },
  mounted() {

  }
};
</script>

<style lang="scss" scoped>
@import "../../../scss/abstracts/variables";

.video-wrapper {
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  position: relative;
  background-color: $brand-grey;

  .video-cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center center;

    .play-button {
      cursor: pointer;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-position: center center;
      background-repeat: no-repeat;
      background-image: url("#{$dir-images}icons/play-icon.svg");

      background-size: 50px 50px;
      width: 50px;
      height: 50px;
      transition: all 300ms;

      &:hover {
        opacity: 0.8;
      }

      @media #{$md} {
        background-size: 100px 100px;
        width: 100px;
        height: 100px;
      }
    }
  }

  video,
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

.content-wrapper {
  margin-top: 3rem;

  :first-child {
    margin-top: 0;
  }

  :last-child {
    margin-bottom: 0;
  }

  .button {
    margin-top: 3rem;
  }

  .title {
    font-family: $font-primary-med;
    
    @media #{$md} {
      font-size: 1.7143em;
    }
  }
}

.element-video {
  // Image float position top
  .float--top {
    position: relative;
    z-index: 1;
    margin-top: 100px;

    &::after {
      content: "";
      display: block;
      background-color: var(--bg-color);
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: -1;
      top: 0;
    }

    .float-elem {
      position: relative;
      top: -100px;
    }
  }

  // Image float position bottom
  .float--bottom {
    position: relative;
    z-index: 1;
    padding-top: 100px;

    &::after {
      content: "";
      display: block;
      background-color: var(--bg-color);
      width: 100%;
      height: 600px;
      position: absolute;
      z-index: -1;
      top: 0;
    }

    .float-elem {
      position: relative;
    }
  }
}
</style>
